<!--编辑简历-基本信息-->
<template>
	<div class="base-info">
		<!--无数据状态-->
		<div class="no-data" v-if="status==0" v-cloak>
			<resume-undone-template blockText="基本资料" :showTitle="true" @editBtnClick="status=2" :editable="editable" />
		</div>

		<!--展示状态-->
		<div class="baseinfo-complete" v-if="status==1" v-cloak>
			<h3>{{name}}<span class="work-status">{{workStatus=='1'?'在职':'离职'}}</span></h3>
			<div class="info-identity" v-cloak>
				<span>{{eduText}}</span>
				<span>{{experience||0}}年工作经验</span>
				<span>{{gender==1?'男':'女'}}</span>
				<span v-if="age">{{age}}岁</span>
				<span>{{location.location}}</span>
				<span v-if="salary!=0">目前年薪{{salary}}万</span>
			</div>
			<div class="info-contact" v-cloak>
				<div>
					<i class="icon icon-phone"><img src="../../assets/img/common/icon-phone.png" /></i>
					<span>{{phone.value}}</span>
				</div>
				<div class="line">|</div>
				<div>
					<i class="icon icon-email"><img src="../../assets/img/common/icon-email.png" /></i>
					<span>{{email.value}}</span>
				</div>
			</div>
			<a href="javascript:;" class="btn-edit" :class="{'disabled':!editable}" @click="editShow">
				<i class="icon">
					<img src="../../assets/img/common/icon-pencil.png" v-if="editable" />
					<img src="../../assets/img/common/icon-pencil-off.png" v-else="!editable"/>
				</i>&nbsp;编辑
			</a>
		</div>

		<!--编辑状态-->
		<div class="editting" v-if="status==2" v-cloak>
			<div class="row-24">
				<div class="row-12">
					<label class="label">姓名</label>
					<input type="text" class="base-input-lg" maxlength="10" v-model="name">
					<p class="error-tips" v-if="nameError">请输入您的姓名</p>
				</div>

				<div class="row-12">
					<label class="label">性别</label>
					<el-select v-model="gender" placeholder="请选择">
						<el-option v-for="item in genderOptions" :key="item.label" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<p class="error-tips" v-if="genderError">请选择您的性别</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">出生日期</label>
					<el-date-picker v-model="birthday" type="date" placeholder="选择日期">
					</el-date-picker>
					<p class="error-tips" v-if="birthdayError">请选择您的出生日期</p>
				</div>
				<div class="row-12">
					<label class="label">居住地址</label>
					<input type="text" class="base-input-lg" placeholder="请选择" @click="locationClick" v-model="location.location">
					<p class="error-tips" v-if="locationError">请选择您的居住地址</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">手机号码</label>
					<input type="text" maxlength="11" class="base-input-lg" :class="{'error':phone.error}" v-model="phone.value">
					<p class="error-tips" v-show="phone.error">请输入正确的手机号码</p>
				</div>
				<div class="row-12">
					<label class="label">电子邮箱</label>
					<input type="text" class="base-input-lg" :class="{'error':email.error}" v-model="email.value">
					<p class="error-tips" v-show="email.error">请输入正确的邮箱地址</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">学历</label>
					<el-select v-model="edu" placeholder="请选择">
						<el-option v-for="item in eduOptions" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<p class="error-tips" v-if="eduError">请选择您的学历</p>
				</div>

				<div class="row-12">
					<label class="label">工作年限</label>
					<el-select v-model="experience" placeholder="请选择">
						<el-option v-for="item in expOptions" :key="item.label" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<p class="error-tips" v-if="experienceError">请选择您的工作年限</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">工作状态</label>
					<el-select v-model="workStatus" placeholder="请选择">
						<el-option v-for="item in workStatusOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<!---->
				<div class="row-12">
					<div class="label">目前年薪
						<div class="secrecy-box fr" style="display: inline-block;line-height: 1;">
							<input type="checkbox" name="keepsecret" v-model="hideSalary" />
							<div class="fake-checker">
								<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!hideSalary" />
								<img src="../../assets/img/common/icon-circle-tick.png" v-if="hideSalary" />
							</div>
							<span>保密</span>
						</div>
					</div>
					<input type="text" class="base-input-lg" :class="{'disabled':hideSalary}" max-length='10' :disabled="hideSalary" v-model="salary">
					<span class="unit">万/年</span>
				</div>
			</div>

			<div class="row-24-block">
				<a href="javascript:;" class="btn-operation btn-save" @click="submitBaseInfoOperation">保存</a>
				<a href="javascript:;" class="btn-operation btn-cancel" @click="cacelEdit">取消</a>
			</div>
		</div>

		<!-- 选择地区 -->
		<modal :isModal="isLocationModal" :isBtn="false" :width="580" :height="490" @btnCancel="btnCancelLocation">
			<span slot="title">选择地址</span>
			<div slot="content">
				<location :propsLocation="propsLocationList" :maxCount="1" @btnCancel="btnCancelLocation" @btnSubmit="btnSubmitLocation"></location>
			</div>
		</modal>

	</div>
</template>

<script>
	import workExperienceOptions from './dataJson.js'
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'
	import { httpGetEduLevel } from '@/api/common' //获取学历等级
	import { httpResumeBaseInfoGet, httpResumeBaseInfoAdd, httpResumeBaseInfoEdit } from '@/api/resume' //1.获取简历基本信息 2.保存编辑

	import Modal from "@/components/Modal/Modal";
	import Location from '@/components/Location/Location.vue'

	export default {
		name: 'ResumeBaseInfo',
		props: {
			orderId: {
				required: true
			},
			orderDetailId: {
				required: true
			},
			resumeId: {
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		components: {
			ResumeUndoneTemplate,
			Modal,
			Location,
		},
		data() {
			return {
				status: 0, //0-没资料，1-展示状态，2-编辑
				name: '',
				nameError: false,
				genderOptions: [{
					value: 1,
					label: '男'
				}, {
					value: 0,
					label: '女'
				}],
				gender: '',
				genderError: false,
				birthday: '',
				birthdayError: false,
				propsLocationList: [], // 地区定义集合
				isLocationModal: false, // 地区弹窗
				locationChild: {},
				location: {
					locationId: '',
					location: ''
				},
				locationError: false,
				age: '',
				phone: {
					value: '',
					error: false
				},
				email: {
					value: '',
					error: false
				},
				eduOptions: [],
				edu: '',
				eduText: '',
				eduError: false,
				expOptions: workExperienceOptions,
				experience: '',
				experienceError: false,
				workStatusOptions: [{
					value: 1,
					label: '在职'
				}, {
					value: 2,
					label: '离职'
				}],
				workStatus: '',
				salary: '',
				hideSalary: false,
			}
		},
		mounted() {
			this.getResumeBaseInfo();
		},
		methods: {
			//提交基本信息的编辑或者初次新增-resumeId判断
			submitBaseInfoOperation() {
				const oData = this.buildData(); //请求的数据
				const canISubmit = this.beforeSave();
				if(!canISubmit) return;
				this.resumeId ? this.saveBaseInfo(oData) : this.addBaseInfo(oData);
			},

			//首次新增
			addBaseInfo(data) {
				httpResumeBaseInfoAdd(data).then(r => {
					console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 1200,
							onClose: () => {
								this.status = 1;
								this.resumeId = r.data;
								this.getResumeBaseInfo();
								this.$emit('now-i-get-resume', this.resumeId);
								this.$emit('set-edit-status', 2);
							}
						});
					} else {
						this.$message.error('保存失败');
					}
				}).catch(error => {
					console.log(error);
					this.$message.error('保存失败');
				});
			},

			//保存基本信息的编辑或者新增
			saveBaseInfo(data) {
				httpResumeBaseInfoEdit(data).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 1200,
							onClose: () => {
								this.getResumeBaseInfo();
								this.status = 1;
								this.$emit('set-edit-status', 2);
							}
						});
					} else {
						this.$message.error('保存失败');
					}
				}).catch(error => {
					console.log(error);
					this.$message.error('保存失败');
				});
			},

			beforeSave() {
				if(!this.name) {
					this.nameError = true;
					return false;
				} else {
					this.nameError = false;
				}

				if(!this.gender && this.gender !== 0) {
					this.genderError = true;
					return false;
				} else {
					this.genderError = false;
				}

				if(!this.birthday) {
					this.birthdayError = true;
					return false;
				} else {
					this.birthdayError = false;
				}

				if(!this.location.locationId) {
					this.locationError = true;
					return false;
				} else {
					this.locationError = false;
				}

				const phoneReg = new RegExp(/^(1)\d{10}$/);
				if(!phoneReg.test(this.phone.value)) {
					this.phone.error = true;
					return false;
				} else {
					this.phone.error = false;
				}

				if(!this.phone.value) {
					this.phone.error = true;
					return false;
				} else {
					this.phone.error = false;
				}

				if(!this.email.value) {
					this.email.error = true;
					return false;
				} else {
					this.email.error = false;
				}

				const emailReg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
				if(!emailReg.test(this.email.value)) {
					this.email.error = true;
					return false;
				} else {
					this.email.error = false
				}

				if(!this.edu) {
					this.eduError = true;
					return false;
				} else {
					this.eduError = false;
				}

				if(!this.experience) {
					this.experienceError = true;
					return false;
				} else {
					this.experienceError = false;
				}

				return true;
			},

			buildData() {
				let BaseInfo = {};
				BaseInfo.orderId = this.orderId || 0; //初次提交时需要
				BaseInfo.orderDetailId = this.orderDetailId || 0; //初次提交时需要
				BaseInfo.resumeId = this.resumeId || 0;
				BaseInfo.name = this.name;
				BaseInfo.gender = this.gender;
				BaseInfo.birthdate = this.birthday;
				BaseInfo.NativeLocation = this.location.locationId;
				BaseInfo.mobileNumber = this.phone.value;
				BaseInfo.email = this.email.value;
				BaseInfo.educationLevelId = this.edu;
				BaseInfo.yearsExperience = this.experience;
				BaseInfo.workStatusId = this.workStatus;
				BaseInfo.annualSalary = this.salary || 0;
				BaseInfo.displayAnnualSalary = this.hideSalary;

				return BaseInfo;
			},

			//验证手机号码
			validatePhone() {
				const phoneReg = new RegExp(/^(1)\d{10}$/);
				phoneReg.test(this.phone.value) ? this.phone.error = false : this.phone.error = true;
			},
			//验证邮箱
			validateEmail() {
				const emailReg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
				emailReg.test(this.email.value) ? this.email.error = false : this.email.error = true;
			},

			//地址选择Start-lyy
			locationClick() {
				this.isLocationModal = true;
				if(this.location.locationId) {
					this.propsLocationList = [{
						locationId: this.location.locationId,
						location: this.location.location
					}];
				} else {
					this.propsLocationList = [];
				}
			},

			// 获取地址
			btnSubmitLocation(item) {
				if(this.locationChild == null) {
					this.$loader({
						tips: '至少选择一项',
						showIcon: false
					})
					return
				}

				this.locationChild = item;
				this.location.locationId = this.locationChild[0].locationId;
				this.location.location = this.locationChild[0].location;
				this.isLocationModal = false
			},
			btnCancelLocation() {
				this.isLocationModal = false
			},
			//地址选择END-lyy

			//打开简历编辑
			editShow() {
				if(!this.editable) return;
				this.status = 2;
				this.$emit('set-edit-status', 1);
			},

			//取消保存编辑-再请求一次数据复原
			cacelEdit() {
				this.getResumeBaseInfo();
				this.$emit('set-edit-status', 2);
			},

			//手动还原原始数据
			resetData() {
				this.name = "";
				this.nameError = false;
				this.gender = '';
				this.genderError = false;
				this.birthday = '';
				this.birthdayError = false;
				this.locationError = false;
				this.age = '';
				this.phone = {
					value: '',
					error: false
				};
				this.email = {
					value: '',
					error: false
				};
				this.edu = '';
				this.eduError = false;
				this.experience = '';
				this.experienceError = false;
				this.workStatus = '';
				this.salary = '';
				this.hideSalary = false;
			},

			//获取简历基本信息
			getResumeBaseInfo() {
				let prama = this.orderId;
				httpResumeBaseInfoGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						const m = r.data;
						this.name = m.name;
						this.gender = Number(m.genderId);
						this.birthday = m.birthdate;
						this.age = m.age;
						this.location.locationId = m.nativeLocationId;
						this.location.location = m.locationName;
						this.phone.value = m.mobileNumber;
						this.email.value = m.email;
						this.edu = Number(m.educationLevelId) || '';
						this.experience = m.yearsExperience
						this.workStatus = Number(m.workStatusId) || '';
						this.salary = m.annualSalary;

						if(this.name && this.phone.value && this.experience) {
							this.status = 1;
						} else {
							this.status = 0;
						}

					} else {
						this.status = 0;
						this.resetData();
					}
					//如果没有获取过学历选项-获取，否则只调用一下学历文本设置
					this.eduOptions.length == 0 ? this.getEducationLevel() : this.setEduLevel();
				}).catch(error => {
					this.status = 0;
					this.$message.error('获取简历基本信息的时候出错');
				})
			},

			//获取学历下拉框选项
			getEducationLevel() {
				httpGetEduLevel({}).then(r => {
					if(r.success) {
						this.eduOptions = r.data;
						this.setEduLevel();
					} else {
						this.$notify({
							title: '警告',
							message: '获取学历等级失败',
							type: 'warning'
						});
					}
				}).catch(error => {
					this.$notify({
						title: '警告',
						message: '获取学历等级失败',
						type: 'warning'
					});
				})
			},

			//设置学历显示文字
			setEduLevel() {
				this.eduOptions.forEach(item => {
					if(item.id == this.edu) {
						this.eduText = item.name;
					}
				})
			}
		}, //methods结束

		watch: {
			'hideSalary': function(val, oldVal) {
				//如果保密
				if(val) {
					this.salary = '';
				}
			}
		}
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
	.secrecy-box {
		position: relative;
		display: inline-block;
		float: right;
		line-height: 1;
		input[name='keepsecret'] {
			position: relative;
			margin-right: 6px;
			opacity: 0;
			z-index: 3;
		}
		.fake-checker {
			position: absolute;
			top: 3px;
			left: 0;
			width: 16px;
			height: 16px;
			overflow: hidden;
			z-index: 2;
			img {
				display: block;
				width: 16px;
				height: 16px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeBaseInfo.vue